<div class="skeleton-contest-wrapper" [class.small-version-wrapper]="smallVersionOnly"></div>
